import { useCallback, useRef, useState } from "react";
import { checkDuplicateContacts, type DuplicateContact } from "api/contacts";

const DEBOUNCE_MS = 500;

export const useDuplicateCheck = () => {
  const [duplicates, setDuplicates] = useState<DuplicateContact[]>([]);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const check = useCallback((emails: string[], phones: string[]) => {
    if (timerRef.current) clearTimeout(timerRef.current);

    const filteredEmails = emails.filter((e) => e.trim().length > 0);
    const filteredPhones = phones
      .filter((p) => p.trim().length > 0)
      .map((p) => `1${p}`);

    if (filteredEmails.length === 0 && filteredPhones.length === 0) {
      setDuplicates([]);
      return;
    }

    timerRef.current = setTimeout(() => {
      checkDuplicateContacts({
        emails: filteredEmails,
        phones: filteredPhones
      })
        .then((res) => setDuplicates(res.duplicates))
        .catch(() => setDuplicates([]));
    }, DEBOUNCE_MS);
  }, []);

  const reset = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setDuplicates([]);
  }, []);

  return { duplicates, check, reset };
};
